import ReactHtmlParser from "react-html-parser";

export default (sopParameters) => ReactHtmlParser(
    `<div>
  <h4>Description - Team Lift</h4>
  <p>
      The associate needs help in handling a heavy package, bag or a cart.
  </p>
  <h4>Resolution Steps</h4>
  <p>
      1. Ask the PA to reach out to the associate to help with the team lift.<br />
      2. Use the right ergonomic techniques to handle the heavy package, bag or cart.<br />
      3. If needed, use the platform to handle the heavy bags.<br />
      4. Once you resolve the request mark task as completed.<br />
  </p>
</div>
`
);



// WEBPACK FOOTER //
// ./src/components/taskExecution/TaskSOP/FallbackSOPWiki/AMZLStations_Team_Lift.jsx